import { EndPoint, LIBRARY_VERSION } from '../utils/consts.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
class EventApiClient {
    constructor(targetURL, apiVersion) {
        this.targetURL = targetURL;
        this.apiVersion = apiVersion;
        this.eventUrl = `${this.targetURL}/${this.apiVersion}/${EndPoint.Events}`;
    }
    /**
     * A function that sends the payload to Sitecore CDP
     * @param body - The Request body for the Sitecore CDP
     * @returns - A promise that resolves with either the Sitecore CDP response object or null
     */
    async send(body) {
        const fetchOptions = {
            body: JSON.stringify(body),
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'X-Library-Version': LIBRARY_VERSION,
            },
            method: 'POST',
        };
        return await fetch(this.eventUrl, fetchOptions)
            .then((response) => response.json())
            .then((data) => data)
            .catch(() => null);
    }
}

export { EventApiClient };
